"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["PaymentComponent"] = "payment_component";
    PageType["UPMComponent"] = "upm_component";
})(PageType = exports.PageType || (exports.PageType = {}));
//# sourceMappingURL=PageType.js.map